// extracted by mini-css-extract-plugin
export default {"title":"TwoRows_title__O4kFY","container":"TwoRows_container__OfOgs","titleAndList":"TwoRows_titleAndList__LCy55","list":"TwoRows_list__5OhQw"};